import { useContext } from 'react';

import RawDataRevisionContext, { RawDataRevisionValues } from './context';

const useRawDataRevision = (): RawDataRevisionValues => useContext(RawDataRevisionContext);

export default useRawDataRevision;
